module.exports = __webpack_public_path__ + "img/03.ed9720aa.jpg";